const MuiList = {
    styleOverrides: {
        root: {
            '& .Mui-selected': {
                fontWeight: 700,
            },
        },
        padding: {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
};
export default MuiList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTXVpTGlzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25maWcvY29tcG9uZW50cy9NdWlMaXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sT0FBTyxHQUFpQztJQUM1QyxjQUFjLEVBQUU7UUFDZCxJQUFJLEVBQUU7WUFDSixpQkFBaUIsRUFBRTtnQkFDakIsVUFBVSxFQUFFLEdBQUc7YUFDaEI7U0FDRjtRQUNELE9BQU8sRUFBRTtZQUNQLFVBQVUsRUFBRSxDQUFDO1lBQ2IsYUFBYSxFQUFFLENBQUM7U0FDakI7S0FDRjtDQUNGLENBQUM7QUFFRixlQUFlLE9BQU8sQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbXBvbmVudHMsIFRoZW1lIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XG5cbmNvbnN0IE11aUxpc3Q6IENvbXBvbmVudHM8VGhlbWU+WydNdWlMaXN0J10gPSB7XG4gIHN0eWxlT3ZlcnJpZGVzOiB7XG4gICAgcm9vdDoge1xuICAgICAgJyYgLk11aS1zZWxlY3RlZCc6IHtcbiAgICAgICAgZm9udFdlaWdodDogNzAwLFxuICAgICAgfSxcbiAgICB9LFxuICAgIHBhZGRpbmc6IHtcbiAgICAgIHBhZGRpbmdUb3A6IDAsXG4gICAgICBwYWRkaW5nQm90dG9tOiAwLFxuICAgIH0sXG4gIH0sXG59O1xuXG5leHBvcnQgZGVmYXVsdCBNdWlMaXN0O1xuIl19